/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Workshopisnottraining3Inputs */

const de__field_workshopisnottraining3 = /** @type {(inputs: _Field_Workshopisnottraining3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Workshopdurchführung`)
};

/**

* @param {_Field_Workshopisnottraining3Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_workshopisnottraining3 = /** @type {((inputs?: _Field_Workshopisnottraining3Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Workshopisnottraining3Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_workshopisnottraining3(inputs)
});
export { _field_workshopisnottraining3 as "_field_workshopIsNotTraining" }